"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSortIcon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _TableSortIcon = require("./TableSortIcon.js");
var _logging = require("../../logging.js");
var _excluded = ["direction", "aria-label"];
function getIconAriaLabel(direction) {
  return direction === 'up' ? 'Sort column (ascending)' : 'Sort column (descending)';
}

/**
 * @deprecated
 * This component will be archived soon.
 * Rather than composing a sortable TableHeaderCell, you can now use the "sortable" prop on the TableHeaderCell component (we also make this accessible for you!).
 * Please refer to the {@link https://encore-web.spotify.net/?path=/docs/components-table-tableheadercell--sortable TableHeaderCell sortable} story to see its implementation.
 * If you need this icon, you can use IconChartUp and IconChartDown from our {@link https://encore-web.spotify.net/?path=/docs/components-icon--all-icons icon library}.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-table-tablesorticon--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TableSortIcon)
 */
var TableSortIcon = exports.TableSortIcon = function TableSortIcon(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'down' : _ref$direction,
    ariaLabel = _ref['aria-label'],
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _logging.warn)('Warning: The `TableSortIcon` component is deprecated. Rather than composing a sortable TableHeaderCell, you can now use the "sortable" prop on the TableHeaderCell component (we also make this accessible for you! Please refer here for more information: https://encore-web.spotify.net/?path=/docs/components-table-tableheadercell--sortable');
  var iconAriaLabel = ariaLabel ? ariaLabel : getIconAriaLabel(direction);
  return /*#__PURE__*/_react["default"].createElement(_TableSortIcon.TableSortIconElement, Object.assign({
    $direction: direction,
    "aria-label": iconAriaLabel
  }, props));
};